export const OPTHINES = {
  voteName: '2019poject/2019health70',
  buttonBg: '#d72620',
  mustSearch: 'Button',
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  themeColor: {
    activeBgColor: '#d72620',
    inactiveBgColor: '#ab190c',
  },
  tickets: {
    textFirst: '票数',
    textLast: '票',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/2019HealthContributionBrand/FirstPage',
    },
    {
      tabName: '我要报名',
      tabPath: '/2019HealthContributionBrand/Register',
    },
    {
      tabName: '推荐报名',
      tabPath: '/2019HealthContributionBrand/Recommend',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019HealthContributionBrand/NewsPage',
    },
    {
      tabName: '评选说明',
      tabPath: '/2019HealthContributionBrand/Rules',
    },
  ],
  healthType: [
    {
      type: 1,
      fullName: '（一）重庆区域医疗高质量发展管理服务贡献力单位(10强)',
      shortName: '重庆区域医疗高质量发展管理服务贡献力单位（10强）',
    },
    {
      type: 2,
      fullName: '（二）重庆医疗服务高质量发展贡献力单位(20强)',
      shortName: '重庆医疗服务高质量发展贡献力单位（20强）',
    },
    // {
    //   type: 8,
    //   fullName: '（三）重庆医疗服务高质量发展贡献力单位（医药企业类）(10强)',
    //   shortName: '重庆医疗服务高质量发展贡献力单位（医药企业类）(10强)',
    // },
    {
      type: 3,
      fullName: '（三）重庆区域医疗高质量发展贡献力单位(10强)',
      shortName: '重庆区域医疗高质量发展贡献力单位（10强）',
    },
    {
      type: 4,
      fullName: '（四）重庆中医药高质量发展贡献力单位(10强)',
      shortName: '重庆中医药高质量发展贡献力单位（10强）',
    },
    {
      type: 5,
      fullName: '（五）重庆妇幼医疗高质量发展贡献力单位(10强)',
      shortName: '重庆妇幼医疗高质量发展贡献力单位（10强）',
    },
    {
      type: 6,
      fullName: '（六）重庆基层医疗高质量发展贡献力单位(10强)',
      shortName: '重庆基层医疗高质量发展贡献力单位（10强）',
    },
    {
      type: 7,
      fullName: '（七）重庆民营医疗高质量发展贡献力单位(10强)',
      shortName: '重庆民营医疗高质量发展贡献力单位（10强）',
    },
  ],
};
